import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpRequest, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter } from 'rxjs/operators';
import { EnvironmentconfigService } from './environmentconfig.service';
import { FileService } from './file.service';
import { URLConst } from '../const/url.const';

@Injectable(
  { providedIn: 'root' }
)
export class WebApiService {

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    private environmentConfigService: EnvironmentconfigService,
    private messageService: NzMessageService,
    private fileService: FileService) {
    /* 总结
    在 Angular 2 中 constructor 一般用于依赖注入或执行简单的数据初始化操作，
    ngOnInit 钩子主要用于执行组件的其它初始化操作或获取组件输入的属性值
    */
  }

  private getLang(): string {
    return sessionStorage.getItem('wmsmlang')
      || localStorage.getItem('wmsmlang')
      || 'zh-TW';
  }

  /**
   * Return an object of json
   * param url
   * param data
   * param isDownload:判断是否是下载
   * returns {Observable<{}>}
   */
  doPost(url, data, isDownload?: boolean, keepOriginalBody = false): Observable<any> {

    const lang = this.getLang();
    const _headers = new HttpHeaders()
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('Accept-Language', lang)
      .set('Authorization', 'Bearer ' + this.authService.getToken())
      .set('IdentityType', this.authService.getCurrentUserInfo()?.userType || '')
      .set('X-Requested-From', 'UI');

    if (Array.isArray(data)) {
      const body: any = data;
      let options;
      if (isDownload) {
        options = { headers: _headers, responseType: 'blob' };
      } else {
        options = { headers: _headers };
      }
      return this.httpClient.post(url, body, options);
    } else if (data instanceof FormData) {
      const _headers = new HttpHeaders()
        .set('Accept-Language', lang)
        .set('Authorization', 'Bearer ' + this.authService.getToken())
        .set('IdentityType', this.authService.getCurrentUserInfo()?.userType || '')
        .set('X-Requested-From', 'UI');
      const body: any = data;
      let options;
      options = { headers: _headers };
      return this.httpClient.post(url, body, options);
    }

    const siteCode = this.authService.getCurrentUserInfo()?.siteNo ?? '';
    const timeZone = this.authService.getCurrentUserInfo()?.timezone ?? +8;
    const pageIndex = data.pageIndex ? data.pageIndex : 0;
    const pageSize = data.pageSize ? data.pageSize : 0;
    const orderBy = data.orderby ? data.orderby : '';
    const postData = data.data ? data.data : data;
    // flag:imbd002,003等几个程序需要
    const flag = data.flag ? data.flag : '';

    const body: any = keepOriginalBody ? postData : {
      userLang: lang, userSiteCode: siteCode, userTimeZone: timeZone,
      pageindex: pageIndex, pageSize: pageSize, orderby: orderBy, data: postData,
      flag: flag
    };
    let options;
    if (isDownload) {
      options = { headers: _headers, responseType: 'blob' };
    } else {
      options = { headers: _headers };
    }
    return this.httpClient.post(url, body, options);
  }
  /**
   * Return an object
   * param url
   * param urlSearchParams url 的查询参数
   * returns {Observable<{}>}
   */
  doGet(url: string, urlSearchParams?: any, isDownload?: boolean): Observable<any> {
    const _url: string = url;
    const lang = this.getLang();
    url += (_url.indexOf('?') > 0 ? '&' : '?') + 'q=' + new Date().getTime();
    const _params = new HttpParams({ fromString: urlSearchParams });
    const _headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.authService.getToken())
      .set('IdentityType', this.authService.getCurrentUserInfo()?.userType || '')
      .set('Accept-Language', lang);
    let options: any = { params: _params, headers: _headers };
    if (isDownload) {
      options.responseType = 'blob';
    }
    return this.httpClient.get(url, options);
  }

  downloadFileByToken(fileToken: string): Observable<any> {
    if (!fileToken) {
      throw new Error('文件ID不能为空');
    }
    const token = encodeURIComponent(fileToken);
    const url = `${this.environmentConfigService.authConfig.MVMBackEnd}/api/File/${token}`;
    return this.doGet(url, '', true);
  }

  getFileAccessInfo(fileToken: string): Observable<any> {
    const url = `${this.environmentConfigService.authConfig.wmsmUrl}${URLConst.GetFileAccessInfo.url}?fileToken=${encodeURIComponent(fileToken)}`;
    return this.doGet(url);
  }

  downloadFileByAccessInfo(fileToken: string): Observable<Blob> {
    return this.getFileAccessInfo(fileToken).pipe(
      switchMap((res) => {
        const shouldEncrypt = !!(res?.data?.shouldEncrypt ?? res?.data?.ShouldEncrypt);
        if (shouldEncrypt) {
          return this.fileService.downloadFileBlob(fileToken).pipe(
            catchError(() => this.downloadFileByToken(fileToken).pipe(
              map((blob) => blob as Blob)
            ))
          );
        }

        return this.downloadFileByToken(fileToken).pipe(
          map((blob) => blob as Blob)
        );
      })
    );
  }
  doGetpost(url: string, data: any): Observable<any> {
    const _headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.authService.getToken())
      .set('IdentityType', this.authService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, data, { headers: _headers });
    return this.httpClient.request(req).pipe(filter(e => e instanceof HttpResponse));
  }
}
